<template>
  <Header_AS @on-change-main-page="getMainPageData()" />
  <!-- Escuela Corporativa - Banner -->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div
          class="img-banner-home-header"
          :style="{ backgroundImage: `url(${fondoEC})` }"
        ></div>
      </div>

      <div class="sobrefondo"></div>

      <div class="container px-5 container-banner-img">
        <div class="stack-badges">
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge d-none d-md-block"
          />
        </div>
      </div>

      <div class="container px-5 banner-text-wrapper">
        <div v-if="isMobile" class="stack-badges-mobile">
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
        </div>

        <div class="banner-text-inner">
          <div :class="['text-start', { aos: !isMobile }]" :data-aos="!isMobile ? 'fade-up' : null">
            <h2 class="banner-title">
              <!-- línea 1 -->
              {{ tituloUnoEC }}

              <!-- línea 2 (debajo), en celeste -->
              <span class="banner-title-culture banner-title-line2">
                {{ tituloDosEC }}
              </span>

              <!-- resto igual al Young Talent -->
              {{ tituloTresEC }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- Section learn -->
  <section class="section-header-learn">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-learn-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            <span>{{ $t("¡Capacitación como motor de crecimiento!") }}</span>
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>

  <section class="section-content-learn" :class="{ 'blur-background': dialog }">
    <div class="container px-5">
      
      <Carousel
        v-if="isMobile"
        ref="carouselLearnMobile"
        class="py-5"
        :autoplay="autoplayMs"
        :wrap-around="true"
        :items-to-show="1"
        :items-to-scroll="1"
      >
        <Slide
          v-for="item in videosEscuela"
          :key="item.id"
        >
          <div class="slide-content-wrapper">
            <div class="grid-item-student position-relative overflow-hidden">
              <video
                class="video-card video-background"
                :src="item.url"
                autoplay
                muted
                loop
                playsinline
                @click="eventDialogVideo(item.url)"
                title="Ver video"
                preload="metadata"
              ></video>

              <span class="grid-item-play" @click="eventDialogVideo(item.url)">
                <i class="bx bx-play"></i>
              </span>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination class="custom-dots" />
        </template>
      </Carousel>
      <Carousel
        v-else
        ref="carouselLearnDesktop"
        class="py-5"
        :autoplay="autoplayMs"
        :wrap-around="true"
        :items-to-show="1"
        :items-to-scroll="1"
      >
        <Slide
          v-for="(grupo, index) in videosEscuela_transform"
          :key="'s2v-'+index"
        >
          <div class="grid-container-student px-3">
            <div
              v-for="item in grupo.items"
              :key="item.id"
              class="grid-item-student position-relative overflow-hidden"
            >
              <video
                class="video-card video-background"
                :src="item.url"
                autoplay
                muted
                loop
                playsinline
                @click="eventDialogVideo(item.url)"
                title="Ver video"
                preload="metadata"
              ></video>

              <span class="grid-item-play" @click="eventDialogVideo(item.url)">
                <i class="bx bx-play"></i>
              </span>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination class="custom-dots" />
        </template>
      </Carousel>

    </div>
  </section>


  <v-dialog v-model="dialog" :width="dialogWidth">
    <v-card :class="['modal-transparent', { 'modal-fullscreen': isMobile }]">
      <!-- BOTÓN CERRAR -->
      <button
        class="close-btn"
        @click="closeModal"
        aria-label="Cerrar video"
        title="Cerrar"
      >
        ✕
      </button>

      <template #text>
        <div class="modal-video-wrapper">
          <video
            ref="modalVideo"
            :src="urlVideo"
            class="modal-video"
            controls
            autoplay
            playsinline
            :style="modalVideoStyle"
          ></video>
        </div>
      </template>
    </v-card>
  </v-dialog>


  <!-- Section student / Sección 3 -->
  <section class="section-header-student">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-student-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            <span>{{ $t("Nuestros graduados") }}</span>
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>

  <section class="section-content-student">
    <div class="container px-5">
      
      <Carousel
        v-if="isMobile"
        class="py-5"
        :autoplay="3000"
        :wrap-around="true"
        :items-to-show="1"
        :items-to-scroll="1"
      >
        <Slide
          v-for="item in dataTestimonio"
          :key="item.id"
        >
          <div class="slide-content-wrapper">
            <div class="grid-item-student">
              <img
                :src="item.img"
                alt="estudiante"
                class="img-student-card"
              />
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination class="custom-dots" />
        </template>
      </Carousel>

      <Carousel
        v-else
        class="py-5"
        :autoplay="3000"
        :wrap-around="true"
        :items-to-show="1"
        :items-to-scroll="1"
      >
        <Slide
          v-for="(grupo, index) in dataTestimonio_transform"
          :key="index"
        >
          <div class="grid-container-student px-3">
            <div
              v-for="item in grupo.items"
              :key="item.id"
              class="grid-item-student"
            >
              <img
                :src="item.img"
                alt="estudiante"
                class="img-student-card"
              />
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination class="custom-dots" />
        </template>
      </Carousel>

    </div>
  </section>


  <!-- Footer -->
  <Footer_AS />
  <!-- Button work -->
  <Button_work_AS />
</template>

<script>
import axiosIns from "@/plugins/axios.js";
import AOS from "aos";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";

import Button_work_AS from "./components/Button_work_AS.vue";
import Footer_AS from "./components/Footer_AS.vue";
import Header_AS from "./components/Header_AS.vue";

export default {
  components: {
    Button_work_AS,
    Carousel,
    Footer_AS,
    Header_AS,
    Pagination,
    Slide,
  },
  data() {
    return {
      dataVideo: [],
      language: null,
      isMobile: window.innerWidth < 768,
      // SECCION 1 EC
      // --- Escuela Corporativa (nuevo)
      fondoEC: "",
      tituloUnoEC: "",
      tituloDosEC: "",
      tituloTresEC: "",

      // seccion 2 
      // SECCIÓN 2
      videosEscuela: [],             // crudo del backend [{ id, url }]
      videosEscuela_transform: [],   // en grupos para el carrusel
      dialog: false,
      urlVideo: "",

      // controla autoplay del carousel (ms o false)
      autoplayMs: 3000,

      // SECCION 3
      dataTestimonio: [],              // crudo del backend
      dataTestimonio_transform: [],    // chunked para el carrusel
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    // escuchamos ESC globalmente
    window.addEventListener("keydown", this.handleKeydown);

    this.handleResize();
    this.getEscuelaCorporativaSeccionUnoEC();
    this.getEscuelaCorporativaSeccionDosEC();
    this.getEscuelaCorporativaSeccionTresEC(); // 👈 SECCION 3

    // AOS animaciones
    AOS.init({ duration: 1000 });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.handleKeydown);
  },
  computed: {
    // dialogWidth se usa por Vuetify; en mobile devolvemos '100%' para que el v-dialog ocupe todo
    dialogWidth() {
      return this.isMobile ? '100%' : '900';
    },
    // estilo dinámico para el video dentro del modal
    modalVideoStyle() {
      if (this.isMobile) {
        // dejar un pequeño padding alrededor para evitar notch / barras
        return {
          width: 'calc(100vw - 32px)',
          height: 'calc(100vh - 120px)',
          maxWidth: '100vw',
          maxHeight: '100vh',
        };
      } else {
        // desktop: tamaño fijo máximo pero responsive
        return {
          width: '800px',
          height: '600px',
          maxWidth: '90vw',
          maxHeight: '80vh',
        };
      }
    }
  },
  watch: {
    // Observa el diálogo para ejecutar limpieza cuando se cierre desde UI (v-model)
    dialog(newVal) {
      if (!newVal) {
        // si se cerró el diálogo, hacemos limpieza
        this.onDialogClose();
      } else {
        // si se abre el diálogo, aseguramos que el modal video vaya a reproducir
        this.$nextTick(() => {
          const mv = this.$refs.modalVideo;
          if (mv && mv.play) {
            // intente reproducir (browser puede bloquear si no hay interacción)
            mv.play().catch(()=>{/* ignore */});
          }
        });
      }
    }
  },
  methods: {

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },

    // manejar ESC global
    handleKeydown(e) {
      if (e.key === "Escape" || e.key === "Esc") {
        if (this.dialog) {
          this.closeModal();
        }
      }
    },

    // SECCION 1 
    async getEscuelaCorporativaSeccionUnoEC() {
      try {
        const { data } = await axiosIns.get(
          "/talentoagv/getEscuelaCorporativaSeccionUnoEC/"
        );

        if (data?.is_error)
          throw new Error(data?.message || "Error en el servidor");

        const result = data.result || [];

        // Fondo dinámico (usa la primera fila que tenga s3_url válido)
        const fondo = result.find((r) => r.s3_url);
        this.fondoEC = fondo ? fondo.s3_url : this.fondoEC;
        const palabras = result
          .map((r) => (r.palabra || "").trim())
          .filter(Boolean);

        this.tituloUnoEC = palabras[0] || "";
        this.tituloDosEC = palabras[1] || "";
        this.tituloTresEC = palabras[2] || "";

      } catch (error) {
        console.error("Error al obtener sección 1 EC:", error);
      }
    },

    // SECCIÓN 2 – cargar videos (sin left/right)
    async getEscuelaCorporativaSeccionDosEC() {
      try {
        const { data } = await axiosIns.get('/talentoagv/getEscuelaCorporativaSeccionDosEC/')
        if (data?.is_error) throw new Error(data?.message || 'Error en el servidor')

        const rows = Array.isArray(data?.result) ? data.result : []

        // Normaliza: esperamos { id_secciondos_ec, s3_video_url }
        const list = rows
          .filter(r => !!r.s3_video_url)
          .map(r => ({
            id: r.id_secciondos_ec ?? r.id ?? crypto.randomUUID(),
            url: r.s3_video_url,
          }))

        this.videosEscuela = list

        // chunk en grupos de 3 (igual que sección 3)
        const chunkSize = 3
        const chunks = []
        for (let i = 0; i < list.length; i += chunkSize) {
          chunks.push({ items: list.slice(i, i + chunkSize) })
        }
        this.videosEscuela_transform = chunks
      } catch (error) {
        console.error('Error al obtener sección 2 EC:', error)
        this.videosEscuela = []
        this.videosEscuela_transform = []
      }
    },

    eventDialogVideo(url) {
      this.pauseAllBackgroundVideos();

      this.autoplayMs = false;
      this.urlVideo = url;
      this.dialog = true;

      document.body.style.overflow = 'hidden';
    },
    pauseAllBackgroundVideos() {
      const videos = document.querySelectorAll('.video-background');
      videos.forEach(v => {
        try {
          v.pause();
        } catch (e) {
          console.warn('Video background pause error:', e);
        }
      });
    },
    closeModal() {
      this.dialog = false
      this.$nextTick(() => {
        const mv = this.$refs.modalVideo;
        if (mv) {
          try {
            mv.pause();
            mv.currentTime = 0;
          } catch (e) {
            console.warn('Modal video pause error:', e);
          }
        }
      });
    },
    onDialogClose() {
      this.autoplayMs = 3000;
      const videos = document.querySelectorAll('.video-background');
      videos.forEach(v => {
        try {
          v.pause();
          v.currentTime = 0;
        } catch (e) {
          console.warn('Video background reset error:', e);
        }
      });
      const mv = this.$refs.modalVideo;
      if (mv) {
        try {
          mv.pause();
          mv.currentTime = 0;
        } catch (e) {
          console.warn('Modal video final reset error:', e);
        }
      }
      this.urlVideo = "";
      document.body.style.overflow = '';
    },

    // SECCION 3 
    async getEscuelaCorporativaSeccionTresEC() {
      try {
        const { data } = await axiosIns.get(
          "/talentoagv/getEscuelaCorporativaSeccionTresEC/"
        );

        if (data?.is_error) {
          throw new Error(data?.message || "Error en el servidor");
        }

        const result = data.result || [];
        const normalizedList = result.map(row => ({
          id: row.id_seccioncuatro,
          img: row.s3_url || "", 
        }));

        this.dataTestimonio = normalizedList;

        const chunkSize = 3;
        const chunks = [];
        for (let i = 0; i < normalizedList.length; i += chunkSize) {
            const slice = normalizedList.slice(i, i + chunkSize);
            chunks.push({ items: slice });
        }

        this.dataTestimonio_transform = chunks;

      } catch (error) {
        console.error("Error al obtener sección 3 EC:", error);
      }
    },

  },
};
</script>

<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/escuela_corporativa_AS.css"></style>
<style scoped>
.banner-title-culture {
  color: #00b8f1;
  font-weight: 700;
}
.banner-title-line2 {
  display: block;        
  line-height: 1.2;
  margin-top: 0.25rem;   
}

/* El contenedor del video */
.content-video-learn {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 260px; /* ajústalo al alto que quieres */
}

/* El video de fondo debe cubrir todo */
.video-banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Capa oscura encima del video */
.content-video-learn .sobrefondo {
  position: absolute;
  inset: 0;
  /* ya traes el background-color inline con rgba(0,0,0,0.3) */
  pointer-events: none;
}

/* Botón play centrado */
.content-text-video-learn {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* evita tap accidental en overlay */
}

.grid-item-play {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  pointer-events: auto; /* <- este sí clickable */
  transition: all .2s ease;
}

.grid-item-play:hover {
  transform: scale(1.07);
}

/* Wrapper para dar espaciado entre slides (simula gap) */
.slide-content-wrapper {
  padding: 0 1rem; /* Espacio horizontal entre items */
  width: 100%;
}

/* Contenedor del slide */
.grid-container-student {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  align-items: stretch;
}

/* Cada tarjeta dentro del slide */
.grid-item-student {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0,0,0,.08);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%; /* Asegura que ocupe el espacio en mobile */
}

/* Imagen del estudiante / testimonio */
.img-student-card {
  width: 100%;
  height: 300px; /* Altura fija base */
  object-fit: cover;
  display: block;
}

/* Efecto visual al abrir modal (opcional) */
.blur-background {
  filter: brightness(0.18);
  transition: filter 0.3s ease;
  /* pointer-events none permite que el overlay capture el click (vuetify) */
  pointer-events: none;
}

/* Modal styles */
.modal-transparent {
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* BOTÓN CERRAR - estilo blanco con X negra */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  background: white;
  color: black;
  border: none;
  border-radius: 50%;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}
.close-btn:active {
  transform: scale(0.9);
}

/* When mobile, make the modal card full screen (we also control dialog width in JS) */
.modal-fullscreen {
  width: 100% !important;
  height: 100% !important;
  margin: 0;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Wrapper around video for proper centering & padding on mobile */
.modal-video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* Modal video: use object-fit: contain to show all frame without crop */
.modal-video {
  display: block;
  border-radius: 12px;
  object-fit: contain;
  background: #040404;
  max-width: 100%;
  max-height: 100%;
  /* For desktop we use the inline styles computed (800x600). For mobile the computed styles use vw/vh */
}

/* Responsive: en pantallas chicas, 1 por fila; medianas, 2; grandes, 3 */
@media (max-width: 991px) {
  .grid-container-student {
    grid-template-columns: repeat(2, 1fr);
  }
  .img-student-card {
    height: 230px;
  }
}
@media (max-width: 576px) {
  .grid-container-student {
    grid-template-columns: repeat(1, 1fr);
  }

  /* Mobile specific: reduce modal padding so the video uses more height */
  .modal-video-wrapper {
    padding: 8px;
  }

  .modal-video {
    border-radius: 8px;
  }

  /* Ajusta la posición del botón cerrar en mobile (un poco más adentro) */
  .close-btn {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 17px;
  }

  .img-student-card {
    height: 200px;
  }
}

/* === SECCIÓN 2 - ESCUELA CORPORATIVA (videos un poco más grandes) === */

/* Más anchas: reducimos gap y ampliamos container */
.section-content-learn .container {
  max-width: 1380px; /* antes 1320px, para expandir el carrusel */
}

.grid-container-student {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px; /* antes 16px */
  align-items: stretch;
}

/* Tarjeta base (fondo blanco intacto) */
.grid-item-student {
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
}

.video-card {
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
  cursor: pointer;
  border-radius: 20px;
  background: #000;
}

.grid-item-play {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  pointer-events: auto;
  transition: transform .2s ease, background .2s ease;
}
.grid-item-play:hover {
  transform: scale(1.08);
  background: rgba(255,255,255,1);
}

/* Responsive: mantiene proporción */
@media (max-width: 991px) {
  .grid-container-student {
    grid-template-columns: repeat(2, 1fr);
  }
  .video-card {
    height: 230px; /* antes 200px */
  }
}
@media (max-width: 576px) {
  .grid-container-student {
    grid-template-columns: repeat(1, 1fr);
  }
  .video-card {
    height: 200px; /* antes 175px */
  }
}
</style>
